import * as R from 'ramda'
import { call, reducer } from '../../helpers/api/meta'
import { getUserProfileDetail, postUserData, getEducationData,
  postEducationData, getProfessionalData, postProfessionalData,
  getLocationData, postLocationData, getAdditionalData, postAdditionalData, 
  getSocialData, postSocialData } from '../../helpers/api/api'

// Action types
export const GET_USERS_PROFILE = 'GET_USERS_PROFILE'
export const POST_USERS_DATA = 'POST_USERS_DATA'
export const GET_EDUCATION_DATA = 'GET_EDUCATION_DATA'
export const POST_EDUCATION_DATA = 'POST_EDUCATION_DATA'
export const GET_PROFESSIONAL_DATA = 'GET_PROFESSIONAL_DATA'
export const POST_PROFESSIONAL_DATA = 'POST_PROFESSIONAL_DATA'
export const GET_LOCATION_DATA = 'GET_LOCATION_DATA'
export const POST_LOCATION_DATA = 'POST_LOCATION_DATA'
export const GET_ADDITIONAL_DATA = 'GET_ADDITIONAL_DATA'
export const POST_ADDITIONAL_DATA = 'POST_ADDITIONAL_DATA'
export const GET_SOCIAL_DATA = 'GET_SOCIAL_DATA'
export const POST_SOCIAL_DATA = 'POST_SOCIAL_DATA'


// API calls


export const callGetUserProfileDetail = (inputs) => {
  const meta = {
    endpoint: (params) => getUserProfileDetail(params),
    inputs,
    action: GET_USERS_PROFILE,
    messages: {
      id: 'getUserProfileDetail',
      failure: 'Could not get user detail'
    }
  }
  return call(meta)
}

export const  callGetEducationData = (inputs) => {
  const meta = {
    endpoint: (params) => getEducationData(params),
    inputs,
    action: GET_EDUCATION_DATA,
    messages: {
      id: 'getEducationData',
      failure: 'Could not get education detail'
    }
  }
  return call(meta)
}

export const callGetProfessionalData = (inputs) => {
  const meta = {
    endpoint: (params) => getProfessionalData(params),
    inputs,
    action: GET_PROFESSIONAL_DATA,
    messages: {
      id: 'getProfessionalData',
      failure: 'Could not get professional detail'
    }
  }
  return call(meta)
}

export const callGetLocationData = (inputs) => {
  const meta = {
    endpoint: (params) => getLocationData(params),
    inputs,
    action: GET_LOCATION_DATA,
    messages: {
      id: 'getLocationData',
      failure: 'Could not get location detail'
    }
  }
  return call(meta)
}

export const callGetAdditionalData = (inputs) => {
  const meta = {
    endpoint: (params) => getAdditionalData(params),
    inputs,
    action: GET_ADDITIONAL_DATA,
    messages: {
      id: 'getAdditionalData',
      failure: 'Could not get additional detail'
    }
  }
  return call(meta)
}

export const callGetSocialData = (inputs) => {
  const meta = {
    endpoint: (params) => getSocialData(params),
    inputs,
    action: GET_SOCIAL_DATA,
    messages: {
      id: 'getSocialData',
      failure: 'Could not get social detail'
    }
  }
  return call(meta)
}


export const callPostUserData = (inputs) => {
  const meta = {
    endpoint: (inputs) => postUserData(inputs),
    inputs,
    action: POST_USERS_DATA,
    messages: {
      id: 'postUserData',
      failure: 'Could not post data'
    }
  }
  return call(meta)
}

export const CallPostEducationData = (inputs) => {
  const meta = {
    endpoint: (body) => postEducationData(body),
    inputs,
    action: POST_EDUCATION_DATA,
    messages: {
      id: 'postEducationData',
      failure: 'Could not add education'
    }
  }
  return call(meta)
}

export const callPostProfessionalData = (inputs) => {
  const meta = {
    endpoint: (body) => postProfessionalData(body),
    inputs,
    action: POST_PROFESSIONAL_DATA,
    messages: {
      id: 'postProfessionalData',
      failure: 'Could not add professional data'
    }
  }
  return call(meta)
}

export const callPostLocationData = (inputs) => {
  const meta = {
    endpoint: (body) => postLocationData(body),
    inputs,
    action: POST_LOCATION_DATA,
    messages: {
      id: 'postLocationData',
      failure: 'Could not add location'
    }
  }
  return call(meta)
}

export const callPostAdditionalData = (inputs) => {
  const meta = {
    endpoint: (body) => postAdditionalData(body),
    inputs,
    action: POST_ADDITIONAL_DATA,
    messages: {
      id: 'postAdditionalData',
      failure: 'Could not add professional detail'
    }
  }
  return call(meta)
}

export const callPostSocialData = (inputs) => {
  const meta = {
    endpoint: (body) => postSocialData(body),
    inputs,
    action: POST_SOCIAL_DATA,
    messages: {
      id: 'postSocialData',
      failure: 'Could not add social detail'
    }
  }
  return call(meta)
}

// Reducer
const initialState = {
  loading: false,
  userDetail: null
}
const saveUsers = (state, action) => {  
  return R.assoc('userDetail', action, state);
}
const messages = {
  loadFailed: 'Could not load users.',
}
export default reducer(initialState, GET_USERS_PROFILE, saveUsers, messages.loadFailed)